export default "__VITE_ASSET__58542907__"